/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Grower_Area_Tab_FallbackInputs */

const vi_grower_area_tab_fallback = /** @type {(inputs: Grower_Area_Tab_FallbackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vùng ${i?.n}`)
};

/**

* @param {Grower_Area_Tab_FallbackInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_tab_fallback = /** @type {((inputs: Grower_Area_Tab_FallbackInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Tab_FallbackInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_tab_fallback(inputs)
});